import { render, staticRenderFns } from "./Temu.vue?vue&type=template&id=a697e880&scoped=true"
import script from "./Temu.vue?vue&type=script&lang=js"
export * from "./Temu.vue?vue&type=script&lang=js"
import style0 from "./Temu.vue?vue&type=style&index=0&id=a697e880&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a697e880",
  null
  
)

export default component.exports